import CompanyCell from '@app/src/components/Table/Cells/CompanyCell'
import DateCell from '@app/src/components/Table/Cells/DateCell'
import ExternalVerificationStatusCell from '@app/src/components/Table/Cells/ExternalVerificationStatusCell'
import PeriodNameCell from '@app/src/components/Table/Cells/PeriodNameCell'
import RequestCell from '@app/src/components/Table/Cells/RequestCell'
import { useInquiryNavigator } from '@app/src/hooks/inquiryNavigator'
import type { Inquiry } from '@app/src/types/resourceExplorer'
import { ExternalVerificationStatus } from '@app/src/types/resourceExplorer'
import { TableRow } from '@mui/material'
import React from 'react'
import ValueCell from '@app/src/components/Table/Cells/ValueCell'

interface ProviderInquiryRowProps {
  row: Inquiry
  showTargetProductColumn?: boolean
}

export const ProviderInquiryRow: React.FC<ProviderInquiryRowProps> = ({ row: inquiry, showTargetProductColumn }) => {
  const { handleInquiryClick, isCreateReportLoading } = useInquiryNavigator()
  const latestResponse = inquiry.request?.responses?.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  )[0]
  const verification = latestResponse?.verifications?.find(
    ver => ver.creatorOrganizationId === inquiry.creatorOrganizationId,
  )

  return (
    <TableRow>
      <ExternalVerificationStatusCell
        responseStatus={verification?.externalVerificationStatus ?? ExternalVerificationStatus.NotSet}
        draftStatus={latestResponse?.draftStatus}
        inquiryStatus={inquiry?.status}
      />
      <RequestCell
        title={inquiry.template?.title}
        imageUrl={inquiry.template?.image?.url}
        isLoading={isCreateReportLoading}
        onClick={() =>
          handleInquiryClick(
            inquiry.questionnaireTemplateId,
            inquiry.periodStartsAt,
            inquiry.periodEndsAt,
            inquiry.id,
            inquiry.request?.id,
            inquiry?.targetProductId,
          )
        }
      />
      {showTargetProductColumn && <ValueCell value={inquiry.targetProduct?.name} />}
      <PeriodNameCell periodName={inquiry.periodName} />
      <CompanyCell company={inquiry.creatorOrganization} />
      <DateCell value={inquiry?.deadline} />
      <DateCell value={inquiry?.activatedAt} />
    </TableRow>
  )
}

export default ProviderInquiryRow
